import styled from 'styled-components'

export const VisuallyHidden = styled.span`
  top: 20px;
  clip: rect(0 0 0 0);
  width: 1px;
  border: 0;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  position: absolute;
`
